import React, { useState } from 'react';
import { FormContainer } from '../../../AdminRoutes/CreateRoutes/CreateForm.styles';
import CreateManagerEmployeeSubmit from './CreateMESubmit.component';
import BreadCrumbs from '../../../Components/Breadcrumbs/BreadcrumbsComponent.component';
import AuthCheckManager from '../../../Utils/AuthCheck/ManagerCheck.auth';
import HelmetHelper from '../../../Components/PageHelmet/HelmetHelper.component';
import ManagerEmployeeInput from '../../../Components/UserForm/ManagerEmployeeInputs.component';

const CreateManagerCompany = () => {
  const [user, setUser] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    password: '',
  });

  const [type, setType] = useState('Manager');

  return (
    <AuthCheckManager>
      <HelmetHelper
        title="Create Manager/Employee"
        description="Form to create an employee or manager"
      />
      <FormContainer>
        <BreadCrumbs
          one="Company Dashboard"
          oneLink={'/company'}
          two="Create Manager/Employee"
        />
        <h2>Create Manager or Employee</h2>
        <ManagerEmployeeInput
          user={user}
          setUser={setUser}
          setType={setType}
          type={type}
          showType={true}
        />
        <CreateManagerEmployeeSubmit user={user} type={type} />
      </FormContainer>
    </AuthCheckManager>
  );
};

export default CreateManagerCompany;
